/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
import createStateManager from './sprayEngine.state.js';
import createCanvasManager from './sprayEngine.canvas.js';
import createUIManager from './sprayEngine.ui.js';
import createEventHandlers from './sprayEngine.events.js';
import * as sprayBasic from './sprayAlgorithms.basic.js';
import * as spraySmall from './sprayAlgorithms.small.js';
import * as sprayRoller from './sprayAlgorithms.roller.js';
import * as sprayNYFat from './sprayAlgorithms.ny_fat.js';
import createNotificationSystem from './sprayEngine.notifications.js';
import createPaintSystem from './sprayEngine.paint.js';
import createPresetManager from './sprayEngine.presets.js';
export default function initSprayEngine(options = {}) {
  const state = createStateManager(options);
  const canvasManager = createCanvasManager({ canvasId: options.canvasId });
  const ui = createUIManager(state);
  const notifications = createNotificationSystem({
    getTranslation: options.getTranslation,
    lang: options.lang
  });
  const paintSystem = createPaintSystem(state, ui);
  const presetManager = createPresetManager(state, options.presets || {});
  const sprayAlgorithms = {
    basic: sprayBasic.sprayAt,
    small: spraySmall.sprayAt10cm,
    roller: sprayRoller.sprayWithRoller,
    ny_fat: sprayNYFat.sprayNYFat
  };
  const events = createEventHandlers({
    state,
    canvasManager,
    ui,
    notifications,
    paintSystem,
    presetManager,
    sprayAlgorithms
  });
  if (canvasManager && canvasManager.ctx && canvasManager.canvas) {
    canvasManager.ctx.clearRect(0, 0, canvasManager.canvas.width, canvasManager.canvas.height);
  }
  if (ui && typeof ui.updateUI === 'function') {
    ui.updateUI();
  }
  window.syncPaintState = state.syncPaintState;
  window.updateSprayParams = presetManager.updateSprayParams;
  window.showToast = notifications.showToast;
  window.clearCanvas = events.clearCanvas;
  window.updateSprayColor = (newColor) => {
    state.config.currentColor = newColor;
    const activeCanIndex = state.cansData.findIndex(c => c.id === state.config.activeCanId);
    if (activeCanIndex !== -1) {
      state.cansData[activeCanIndex].color = newColor;
    }
  };
  window.setPreviewMode = (isPreview, previewCtx) => {
    state.isPreview = isPreview;
    if (isPreview && previewCtx) {
      canvasManager.setPreviewTarget(previewCtx);
    } else {
      canvasManager.setPreviewTarget(null);
    }
  };
  window.setActiveCan = (canId, newColor, newCansData) => {
    if (newCansData) {
      state.syncPaintState(newCansData);
    }
    if (canId) {
      state.config.activeCanId = canId;
      const activeCan = state.cansData.find(c => c.id === canId);
      if (activeCan) {
        const colorToSet = newColor || activeCan.color || state.config.currentColor;
        state.config.currentColor = colorToSet;
        const canIndex = state.cansData.findIndex(c => c.id === canId);
        if (canIndex !== -1) state.cansData[canIndex].color = colorToSet;
        state.config.paintLeft = typeof activeCan.paintLeft === 'number'
          ? activeCan.paintLeft
          : state.config.paintMax;
      }
    }
  };
  window.updatePaintLeft = (canId, newPaintLeft) => {
    if (typeof window.onPaintUpdate === 'function') {
      window.onPaintUpdate(canId, newPaintLeft);
    }
  };
  window.setFlatMode = (val) => {
    state.flatMode = !!val;
  };
  window.setUserOverride = (key, value) => {
    state.userOverrides = state.userOverrides || {};
    state.userOverrides[key] = value;
  };
  window.setUserOverrides = (obj) => {
    state.userOverrides = Object.assign(state.userOverrides || {}, obj || {});
  };
  window.drawRemotePoint = events.handleRemotePoint;
  return {
    syncPaintState: state.syncPaintState,
    updateSprayParams: presetManager.updateSprayParams,
    updateSprayColor: (c) => { state.config.currentColor = c; },
    clearCanvas: events.clearCanvas,
    drawRemotePoint: events.handleRemotePoint,
    state,
    canvas: canvasManager,
    ui,
    notifications,
    paintSystem,
    sprayAlgorithms
  };
}
